import React from 'react';
import './WhyUs.css';
import { IoChevronBackOutline } from "react-icons/io5";
import { Link } from 'react-router-dom';

import whyusImage from '../../assets/img2.png';

const WhyUs = () => {
  return (

    <div className='container'>
      <section className='message'>
        <div className='right-message'>
          <div className='our-message'>
            <h2>لماذا نحن</h2>
            <div className='title__line'></div>
            <p>
              الالتزام بالامانة والصدق مع مساهمينا من أصحاب الشركات لتقديم خدمة الموارد البشرية لصاحب العمل والموظف وان نكون شركة توظيف صداقة ذات مصدقية موثوقة كشركة عالمية رائدة في وكالة توظيف قوى عاملة في مصر
            </p>
          </div>

          <Link to='/about' className='read__more'>
            اقرأ المزيد
            <IoChevronBackOutline />
          </Link>
        </div>
        <div className='left-message'>
          <img src={whyusImage} alt="لماذا نحن - شركة التوظيف الرائدة" />
        </div>
      </section>
    </div>

  );
};

export default WhyUs;